import { render, staticRenderFns } from "./TemplateViewer.vue?vue&type=template&id=28be7333&scoped=true"
import script from "./TemplateViewer.vue?vue&type=script&lang=js"
export * from "./TemplateViewer.vue?vue&type=script&lang=js"
import style0 from "./TemplateViewer.vue?vue&type=style&index=0&id=28be7333&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28be7333",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28be7333')) {
      api.createRecord('28be7333', component.options)
    } else {
      api.reload('28be7333', component.options)
    }
    module.hot.accept("./TemplateViewer.vue?vue&type=template&id=28be7333&scoped=true", function () {
      api.rerender('28be7333', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/TemplateViewer.vue"
export default component.exports